var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-summary-wrapper", attrs: { id: "formSummary" } },
    [
      _c("div", { staticClass: "form-summary" }, [
        _c("div", { staticClass: "form-summary__inner" }, [
          _c("h3", { staticClass: "form-summary__title" }, [
            _vm._v("Jouw uitje"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-summary__options" }, [
            _c("div", { staticClass: "option" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.arrangement,
                      expression: "arrangement",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "check",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-check",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.arrangement.name,
                      expression: "!arrangement.name",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "warning",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-order-error",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option__data" },
                [
                  _c("h4", { staticClass: "option__title" }, [
                    _vm._v("Activiteiten"),
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.arrangement.name,
                            expression: "arrangement.name",
                          },
                        ],
                        staticClass: "option__description",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.arrangement.category) +
                              ": " +
                              _vm._s(_vm.arrangement.name)
                          ),
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c("span"),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "option" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.reservation_date && _vm.reservation_time,
                      expression: "reservation_date && reservation_time",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "check",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-check",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.reservation_date && _vm.reservation_time,
                      expression: "!reservation_date && reservation_time",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "warning",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-order-error",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option__data" },
                [
                  _c("h4", { staticClass: "option__title" }, [
                    _vm._v("Agenda"),
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.reservation_date && _vm.reservation_time
                      ? _c("div", { staticClass: "option__description" }, [
                          _vm._v(
                            "\n                      " +
                              _vm._s(_vm.reservation_date) +
                              " om " +
                              _vm._s(_vm.reservation_time) +
                              " uur\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "option totals" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.no_persons,
                      expression: "no_persons",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "check",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-check",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.no_persons,
                      expression: "!no_persons",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "warning",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-order-error",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option__data" },
                [
                  _c("h4", { staticClass: "option__title" }, [_vm._v("Prijs")]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.no_persons,
                            expression: "no_persons",
                          },
                        ],
                        staticClass: "option__totals",
                      },
                      [
                        _c("div", { staticClass: "totals__row" }, [
                          _c("span", [_vm._v(_vm._s(_vm.no_persons) + "x")]),
                          _vm._v(" " + _vm._s(_vm.arrangement.name) + " "),
                          _c("span", { staticStyle: { display: "inline" } }, [
                            _vm._v(
                              "(" +
                                _vm._s(
                                  _vm.$n(_vm.arrangement.price, "currency")
                                ) +
                                " p.p.)"
                            ),
                          ]),
                          _c("br"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.extras, function (product, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "totals__row" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(product.quantity) + "x"),
                              ]),
                              _vm._v(" " + _vm._s(product.name) + " "),
                              _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.$n(product.price, "currency")) +
                                    " p.p.)"
                                ),
                              ]),
                              _c("br"),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "totals__total" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Totaal:"),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$n(_vm.price_total, "currency")) +
                              "\n                      "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "option" }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.client_name,
                      expression: "client_name",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "check",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-check",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.client_name,
                      expression: "!client_name",
                    },
                  ],
                  staticClass: "option__icon",
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "warning",
                      attrs: { width: "100%", height: "100%" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-order-error",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "option__data" },
                [
                  _c("h4", { staticClass: "option__title" }, [
                    _vm._v("Persoonsgegevens"),
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.client_name,
                            expression: "client_name",
                          },
                        ],
                        staticClass: "option__description",
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.client_name,
                                expression: "client_name",
                              },
                            ],
                          },
                          [_vm._v(_vm._s(_vm.client_name) + " "), _c("br")]
                        ),
                        _vm._v(" "),
                        _vm.client_phone
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.client_phone) + " "),
                              _c("br"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.client_email
                          ? _c("span", [_vm._v(_vm._s(_vm.client_email))])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.order_status,
                    expression: "!order_status",
                  },
                ],
                staticClass: "option checkbox",
              },
              [
                _c("div", { staticClass: "option__data" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.check_terms,
                        expression: "check_terms",
                      },
                    ],
                    attrs: {
                      id: "check1",
                      type: "checkbox",
                      name: "check1",
                      value: "",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.check_terms)
                        ? _vm._i(_vm.check_terms, "") > -1
                        : _vm.check_terms,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.check_terms,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.check_terms = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.check_terms = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.check_terms = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$v.check_terms.$touch()
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.order_status,
                    expression: "!order_status",
                  },
                ],
                staticClass: "option checkbox",
              },
              [
                _c("div", { staticClass: "option__data" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.check_privacy,
                        expression: "check_privacy",
                      },
                    ],
                    attrs: {
                      id: "check2",
                      type: "checkbox",
                      name: "check2",
                      value: "",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.check_privacy)
                        ? _vm._i(_vm.check_privacy, "") > -1
                        : _vm.check_privacy,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.check_privacy,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.check_privacy = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.check_privacy = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.check_privacy = $$c
                          }
                        },
                        function ($event) {
                          return _vm.$v.check_privacy.$touch()
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(2),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.order_status,
                    expression: "!order_status",
                  },
                ],
                staticClass: "option checkbox",
              },
              [
                _c("div", { staticClass: "option__data" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newsletter,
                        expression: "newsletter",
                      },
                    ],
                    attrs: {
                      id: "check3",
                      type: "checkbox",
                      name: "check3",
                      value: "",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.newsletter)
                        ? _vm._i(_vm.newsletter, "") > -1
                        : _vm.newsletter,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.newsletter,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = "",
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.newsletter = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.newsletter = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.newsletter = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "label", attrs: { for: "check3" } },
                    [_vm._v("Ja, ik schrijf me in voor de nieuwsbrief.")]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.order_status,
                  expression: "!order_status",
                },
              ],
              staticClass: "button secondary has-icon has-angle submit-button",
              attrs: {
                type: "submit",
                href: "#",
                disabled: !_vm.reservation_valid,
              },
            },
            [
              _c("use", {
                attrs: {
                  "xlink:href":
                    "/wp-content/themes/battlehouse/dist/images/spritemap.svg#reserve-icon",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Reserveren")]),
              _vm._v(" "),
              _c("use", {
                attrs: {
                  "xlink:href":
                    "/wp-content/themes/battlehouse/dist/images/spritemap.svg#angle-right",
                },
              }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "option info" }, [
      _c("strong", [_vm._v("Let op:")]),
      _vm._v(
        " je dient hier een reserveringsverzoek in bij Battlehouse Heerenveen. Je ontvangt een bevestiging zodra het verzoek is goedgekeurd. Betalen kan op locatie."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label", attrs: { for: "check1" } }, [
      _vm._v("Ja, ik ga ga akkoord met de "),
      _c("a", { attrs: { target: "_blank", href: "/algemene-voorwaarden" } }, [
        _vm._v("algemene voorwaarden"),
      ]),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "label", attrs: { for: "check2" } }, [
      _vm._v("Ja, ik ga akkoord met "),
      _c("a", { attrs: { target: "_blank", href: "/privacy-policy" } }, [
        _vm._v("privacybeleid"),
      ]),
      _vm._v("."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/orderSummary.vue